module.exports = __webpack_public_path__ + "media/application/images/logo-09ae8443373a093d029f44dd6603b347.svg";